import './Authors.scss';
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import SnackbarContext from "../../context/SnackbarContext";
import { API_BASE_URL } from '../../config';

export default function Authors() {
    const navigate = useNavigate();
    const { setSnackbar } = useContext(SnackbarContext);

    const [authors, setAuthors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/books/authors/`);
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                const data = await r.json();
                if (!cancelled) setAuthors(data.authors ?? []);
            } catch {
                if (!cancelled) setSnackbar({ content: 'تعذر تحميل قائمة الكتّاب', success: false });
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [setSnackbar]);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return authors;
        return authors.filter(a => a.username.toLowerCase().includes(q));
    }, [authors, query]);

    return (
        <>
        <Navbar />
        <main className='auth-page'>
            <div className='auth-container'>
                <header className='auth-header'>
                    <h1>تعرّف على الكتّاب</h1>
                    <p>كل كاتب نشر كتابًا واحدًا على الأقل باسمه. اضغط لزيارة صفحته وقراءة كتبه.</p>
                </header>

                <input
                    className='auth-search'
                    type='search'
                    placeholder='ابحث باسم الكاتب…'
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    aria-label='ابحث في الكتّاب'
                />

                {loading ? (
                    <p className='auth-empty'>جارٍ التحميل…</p>
                ) : filtered.length === 0 ? (
                    <p className='auth-empty'>
                        {authors.length === 0 ? 'لا يوجد كتّاب بعد.' : 'لا نتائج تطابق بحثك.'}
                    </p>
                ) : (
                    <ul className='auth-grid'>
                        {filtered.map(a => (
                            <li key={a.username}>
                                <button
                                    className='auth-card'
                                    onClick={() => navigate(`/author/${encodeURIComponent(a.username)}`)}
                                >
                                    <div className='auth-avatar'>
                                        {a.username.slice(0, 1).toUpperCase()}
                                    </div>
                                    <div className='auth-info'>
                                        <span className='auth-name'>{a.username}</span>
                                        <span className='auth-count'>
                                            {a.book_count} {a.book_count === 1 ? 'كتاب' : 'كتب'}
                                        </span>
                                    </div>
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </main>
        <Footer />
        </>
    );
}
